import {Injectable} from "@angular/core";
import {Restangular} from "ngx-restangular";

@Injectable()
export class TrainingService {

  constructor(private restangular: Restangular) {
  }

  public trainingCategoryTable() {
    return this.restangular.all("trainingCategoryTable");
  }

  public trainingGroupTable() {
    return this.restangular.all("trainingGroupTable");
  }

  public categoryDelete(id) {
    return this.restangular.one("training_categories/" + id);
  }

  public categoryStore() {
    return this.restangular.all("training_categories");
  }

  public categoryGroup() {
    return this.restangular.all("training_groups");
  }

  public trainingLanguageTable() {
    return this.restangular.all("trainingLanguageTable");

  }

  public languageStore() {
    return this.restangular.all("training_languages");

  }

  public languageDelete(id) {
    return this.restangular.one("training_languages/" + id);

  }

  public trainingProviderTable() {
    return this.restangular.all("trainingProviderTable");

  }

  public getCountryDrop() {
    return this.restangular.one("countrymasters");
  }

  public getLocationsByCountry() {
    return this.restangular.one("getLocationsByCountry");
  }

  public trainingProividerStore() {
    return this.restangular.all("training_providers");
  }

  public trainingProviderDelete(id) {
    return this.restangular.one("training_providers/" + id);
  }

  public trainingInstructorTable() {
    return this.restangular.all("trainingInstructorTable");
  }

  public trainingInstructorDelete(id) {
    return this.restangular.one("training_instructors/" + id);
  }

  public getTypeheadEmployees() {
    return this.restangular.one("getTypeheadEmployees");
  }

  public getLanguageDrop(companyID) {
    return this.restangular.one("training_languages/" + companyID);
  }

  public storeInstructor() {
    return this.restangular.all("training_instructors");
  }

  public trainingCourseTable() {
    return this.restangular.all("trainingCourseTable");
  }

  public getCourseFormData() {
    return this.restangular.one("getCourseFormData");
  }

  public trainingCourseStore() {
    return this.restangular.all("training_courses");
  }

  public trainingCourseDelete(id) {
    return this.restangular.one("training_courses/" + id);
  }

  public getMatrixFormData() {
    return this.restangular.one("getMatrixFormData");
  }

  public searchMatrix() {
    return this.restangular.all("searchMatrix");
  }

  public updateMatrixData() {
    return this.restangular.all("updateMatrixData");
  }



  

  public searchMatrixProjects() {
    return this.restangular.all("searchMatrixProjects");
  }

  public updateMatrixDataProject() {
    return this.restangular.all("updateMatrixDataProject");
  }






  public getallCalendarDropdown() {
    return this.restangular.one("getallCalendarDropdown");
  }

  public getTrainingCalendarLocationsByCountry() {
    return this.restangular.all("getTrainingCalendarLocationsByCountry");
  }

  public getTrainingInstructor() {
    return this.restangular.all("getTrainingInstructor");
  }

  public storeCalendar() {
    return this.restangular.all("training_calendars");
  }




  public getCalendarDetails() {
    return this.restangular.all("getCalendarDetails");
  }

  public getCalendarDetailsTraining() {
    return this.restangular.all("getCalendarDetailsTraining");
  }






  public getCalendarMaster(id) {
    return this.restangular.one("training_calendars/" + id);
  }

  public updateTrainingCalendarDate(id) {
    return this.restangular.one("updateTrainingCalendarDate/" + id);
  }




  public traininngCalendarDelete(id) {
    return this.restangular.one("training_calendars/" + id);
  }

  public getFilterCourse() {
    return this.restangular.all("getFilterCourse");
  }

  public groupDelete(id) {
    return this.restangular.all("training_groups/" + id);
  }

  public getEmployeeTrainingRecord() {
    return this.restangular.all("getEmployeeTrainingRecord");
  }

  public gettrainingCalendarDetails() {
    return this.restangular.all("gettrainingCalendarDetails");
  }

  public trainingRecordTable() {
    return this.restangular.all("trainingRecordTable");
  }

//trainingRecordTableaddEmp

public trainingRecordTableaddEmp(id) {
  return this.restangular.one("trainingRecordTableaddEmp/"+id);

}

public trainingRecordTableaddEmp2(id) {
  return this.restangular.one("trainingRecordTableaddEmp2/"+id);

}

     
  public trainingRecordTableCalender() {
    return this.restangular.all("trainingRecordTableCalender");
  }

  public trainingRecordTableCalenderNomi() {
    return this.restangular.all("trainingRecordTableCalenderNomi");
  }








  public removeTrainingRecord(id) {
    return this.restangular.one("training_records/" + id);
  }

  public updateTrainingRecord(id) {
    return this.restangular.one("training_records_update/" + id);
  }

  public addTrainingRecordEmployee() {
    return this.restangular.all("training_records");
  }

  public updateTrainingEmployees() {
    return this.restangular.all("updateTrainingEmployees");
  }

  public gettrainingColor() {
    return this.restangular.one("training_colors");
  }

  public reportEmployeePercentage() {
    return this.restangular.all("reportEmployeePercentage");
  }

  public getCompetenceSetupFormData() {
    return this.restangular.one("getCompetenceSetupFormData");
  }

  public getAllCompetenceSetup() {
    return this.restangular.all("getAllCompetenceSetup");
  }

  public competenceSetupCRUD() {
    return this.restangular.all("competence_setups");
  }

  public competenceSetupUD(id = 0) {
    let url = "competence_setups";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restangular.one(url);
  }

  public searchCompetenceMatrix() {
    return this.restangular.all("searchCompetenceMatrix");
  }

  public competenceMatrixCRUD() {
    return this.restangular.all("competence_matrices");
  }

  public getReportingEmployees() {
    return this.restangular.one("getReportingEmployees");
  }

  public getCalenderListByCourse() {
    return this.restangular.one("getCalenderListByCourse");
  }

  public trainingRecordPdf() {
    return this.restangular.one('trainingRecordPdf');
  }

  public calenderEventResultPrint() {
    return this.restangular.one('calenderEventResultPrint');
  }

  public trainingCoursesApproval() {
    return this.restangular.all('trainingCoursesApproval');
  }

  public approveDocument() {
    return this.restangular.all('approveTrainingCourse');
  }

  public rejectDocument() {
    return this.restangular.all('trainingCoursesReject');
  }

  public getAudienceByCourse() {
    return this.restangular.one('getAudienceByCourse');
  }

  public courseCategoryCRUD() {
    return this.restangular.all("course_categories");
  }

  public courseCategoryUD(id = 0) {
    let url = "course_categories";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restangular.one(url);
  }


  public courseCategoryDelete(id = 0) {
    let url = "course_categories";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restangular.one(url);
  }


  
  public getAllCourseCategory() {
    return this.restangular.all("getAllCourseCategory");
  }

  public courseLevelCRUD() {
    return this.restangular.all("course_levels");
  }

  public  courseMasterCRUD(){
    return this.restangular.all("course-master");
  }

  public  courseMasterUp(id=0){
    let url = "course-master";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restangular.one(url);

  }

  public courseLevelUD(id = 0) {
    let url = "course_levels";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restangular.one(url);
  }

  public getAllCourseLevels() {
    return this.restangular.all("getAllCourseLevels");
  }


  public getAllCourseMasters() {
    return this.restangular.all("getAllCourseMasters");
  }

  public getAllCourseMastersActive() {
    return this.restangular.all("getAllCourseMastersActive");
  }

  
  //

  public coursesByDesignation() {
    return this.restangular.one('coursesByDesignation');
  }

  public trainingCostTable() {
    return this.restangular.all("trainingCostTable");
  }

  public addTrainingCost() {
    return this.restangular.all("training_cost_details");
  }

  public updateTrainingCost(id) {
    return this.restangular.all('training_cost_details/' + id);
  }

  public trainingAttendanceTable() {
    return this.restangular.all("trainingAttendanceTable");
  }

  public generateEmployeeAttendance() {
    return this.restangular.all("generateEmployeeAttendance");
  }


  public confirmtrainingRecordApprovals(id) {
    return this.restangular.one("confirmtrainingRecordApprovals/" + id);
  }



  public updateEmployeeAttendance(id) {
    return this.restangular.all('training_attendance_details/' + id);
  }

  public printTrainingAttendancePDF() {
    return this.restangular.all("printTrainingAttendancePDF");
  }

  public allTrainingRecordsByEvent() {
    return this.restangular.one("allTrainingRecordsByEvent");
  }

  public courseDesignationsUD(id = 0) {
    let url = "course_designations";
    if (id > 0) {
      url = url + "/" + id;
    }
    return this.restangular.one(url);
  }

  public cancelTrainingRecord()
  {
    return this.restangular.all("cancelTrainingRecord");
  }

  public courseDetailReportData(pageNumber) {
    return this.restangular.all("courseDetailReportData?page=" + pageNumber);
  }

  public getAllKnowledgePhase() {
    return this.restangular.all("getAllKnowledgePhase");
  }

  public knowledgePhaseCRUD() {
    return this.restangular.all("knowledge_phases");
  }

  public knowledgePhaseUpdate(id) {
    return this.restangular.one("knowledge_phases/" + id);
  }

  public getAllTaskDefinition() {
    return this.restangular.all("getAllTaskDefinition");
  }

  public getTaskDefinitionFormData() {
    return this.restangular.one("getTaskDefinitionFormData");
  }

  public taskDefinitionCRUD() {
    return this.restangular.all("task_definitions");
  }

    public taskDefinitionUpdate(id) {
    return this.restangular.one("task_definitions/" + id);
  }

  public getAllKnowledgeDefinition() {
    return this.restangular.all("getAllKnowledgeDefinition");
  }

  public getKnowledgeDefinitionFormData() {
    return this.restangular.one("getKnowledgeDefinitionFormData");
  }

  public knowledgeDefinitionCRUD() {
    return this.restangular.all("knowledge_definitions");
  }

    public knowledgeDefinitionUpdate(id) {
    return this.restangular.one("knowledge_definitions/" + id);
  }

  public getTrainingProgramFormData() {
    return this.restangular.one("getTrainingProgramFormData");
  }

  public trainingProgramCRUD() {
    return this.restangular.all("training_program_masters");
  }

  public trainingProgramUpdate(id) {
    return this.restangular.one("training_program_masters/" + id);
  }

  public getAllTrainingProgramMasters() {
    return this.restangular.all("getAllTrainingProgramMasters");
  }

  public getTaskDefinitionByKnowledge() {
    return this.restangular.one("getTaskDefinitionByKnowledge");
  }

  public getTrainingProgramByID(id) {
    return this.restangular.one("training_program_masters/" + id);
  }

  public getUserTrainingProgramFormData() {
    return this.restangular.one("getUserTrainingProgramFormData");
  }

  public getUserTrainingProgram(id) {
    return this.restangular.one("training_programs/" + id);
  }

  public getJobLogFormData() {
    return this.restangular.one("getJobLogFormData");
  }

  public jobLogCRUD() {
    return this.restangular.all("job_logs");
  }

  printTrainingProgramTaskSheet() {
    return this.restangular.one('printTrainingProgramTaskSheet');
  }

  public getKnowledgeDefinitionByDesignation() {
    return this.restangular.all("getKnowledgeDefinitionByDesignation");
  }

  public getAllTrainingProgramEmployees() {
    return this.restangular.all("getAllTrainingProgramEmployees");
  }

  public getAllTrainingProgramTeamEmployees() {
    return this.restangular.all("getAllTrainingProgramTeamEmployees");
  }

  public getTrainingEmployeesFormData() {
    return this.restangular.one("getTrainingEmployeesFormData");
  }

  public trainingProgramEmployeeCRUD() {
    return this.restangular.all("employees_training_programs");
  }

  public getKnowledgeMaster() {
    return this.restangular.one("getKnowledgeMaster");
  }

  public updateEmployeeTaskStatus() {
    return this.restangular.all("updateEmployeeTaskStatus");
  }

  public updateEmployeeCourseStatus() {
    return this.restangular.all("updateEmployeeCourseStatus");
  }

  public getCertificationHistory() {
    return this.restangular.all("getCertificationHistory");
  }

  
  public updateEmployeeTaskSignOff() {
    return this.restangular.all("updateEmployeeTaskSignOff");
  }

  public getTrainingCourse(id) {
    return this.restangular.one("training_courses/" + id);
  }

  public updateTrainingCourse(id) {
    return this.restangular.one("training_courses/" + id);
  }

  public deleteTaskDefinition(id) {
    return this.restangular.one("task_definitions/"+ id);
  }

  public deleteKnowledgeDefinition(id) {
    return this.restangular.one("knowledge_definitions/"+ id);
  }

  public getNotificationTimeFormData() {
    return this.restangular.one("getNotificationTimeFormData");
  }

  public getCourseNotifications() {
    return this.restangular.one("course_notifications");
  }

  public courseNotificationCRUD() {
    return this.restangular.all("course_notifications");
  }

  public knowledgeDefinitionTasksCRUD() {
    return this.restangular.all("knowledge_definition_tasks");
  }

  public getTrainingComplienceReportData() {
    return this.restangular.all("trainingComplianceReportData");
  }

  public getTrainingComplianceFormData() {
    return this.restangular.one("getTrainingComplianceFormData");
  }

  public deleteTrainingProgramEmployee() {
    return this.restangular.all("deleteTrainingProgramEmployee");
  }

  
  getEmployeesTrainingProgramFormData() {
    return this.restangular.one("getEmployeesTrainingProgramFormData");
  }

  public trainingComplianceDrillDown() {
    return this.restangular.all("trainingComplianceDrillDown");
  }

  public getEmployeesTrainingCourseHistory() {
    return this.restangular.all("getEmployeesTrainingCourseHistory");
  }

  public getTrainingHistoryReportData() {
    return this.restangular.all("trainingHistoryReportData");
  }

  public downloadSampleCSV() {
    return this.restangular.all("downloadSampleCSV");
  }

  public getAllEmployeesForTrainingHistory() {
    return this.restangular.one("getAllEmployeesForTrainingHistory");
  } 

  public trainingHistoryCRUD() {
    return this.restangular.all("training_histories");
  }

  public getHistoryDetails(id) {
    return this.restangular.one("training_histories/" + id);
  }

  public removeHistoryRecord() {
    return this.restangular.all('removeHistoryRecord');
  }

  getTrainingCourseByCategoryMulti() {
    return this.restangular.all('getTrainingCourseByCategoryMulti');
  }


  public removeDependant(id) {
    return this.restangular.one("removeDependant/" + id);
  }

  public trainingResordsTotal(id) {
    return this.restangular.one("trainingResordsTotal/" + id);
  }

  public trainingNominationTotal(id) {
    return this.restangular.one("trainingNominationTotal/" + id);
  }

  public trainingResordsList() {
    return this.restangular.one("trainingResordsList");
  }

  // public trainingNominationList(id, statusID) {
  //   return this.restangular.one("trainingNominationList/" + id +'/'  +statusID);
  // }

  public trainingNominationList() {
    return this.restangular.one("trainingNominationList");
  }



  // ----------- GENERATE CERTIFICATE ------------- //

  // public generateCertificate(id) {
  //   return this.restangular.one("training_records/" + id);
  // }

  generateCertificate() {
    return this.restangular.one('generateCertificate');
  }


  public removeEmployeeCourse() {
    return this.restangular.all("removeEmployeeCourse");   //removeOneEmployeeInProject
  }

  public getTrainingCourses(id) {
    return this.restangular.one("getTrainingCourses/" + id);
  }



  public addCourseEmployees() {
    return this.restangular.all("addCourseEmployees");
  }


  getSelectedDepartmentDesignationMulti() {
    return this.restangular.all('getSelectedDepartmentDesignationMulti');
  }



}



// WEBPACK FOOTER //
// /app/src/app/services/training.service.ts